<template>
  <el-container class="data-container">
    <el-header class="box add bb df">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>haacp标准生产流程</el-breadcrumb-item>
        <el-breadcrumb-item>工艺列表</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button size="medium" type="primary" @click="method_add"
        >新增工艺</el-button
      >
    </el-header>
    <el-main class="p15 pt0">
      <!-- <el-form :inline="true" :model="query" class="demo-form-inline">
        <div class="df aic" style="margin-top: 20px">
          <el-form-item size="medium" style="flex: 0 0 20%" class="mr10">
            <el-input
              placeholder="关键词搜索"
              v-model="query.keyword"
              clearable
              class="input-with-select"
              @clear="search"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="状态" size="medium" class="mr10">
            <el-select v-model="query.status" placeholder="全部" clearable>
              <el-option label="启用" value="1"></el-option>
              <el-option label="禁用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            @click="search"
            style="height: 34px; margin-bottom: 20px; border: none"
            class="mr10"
            >查询</el-button
          >
        </div>
      </el-form> -->
      <div class="box list">
        <el-table border :data="data_tableData" style="width: 100%">
          <!-- <el-table-column
            prop="id"
            min-width="80"
            :show-overflow-tooltip="true"
            label="ID"
            align="center"
          ></el-table-column> -->
          <el-table-column
            prop="name"
            min-width="120"
            :show-overflow-tooltip="true"
            label="模板名称"
            align="center"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="type"
            min-width="120"
            :show-overflow-tooltip="true"
            label="模板类型"
            align="center"
          >
          </el-table-column> -->
          <el-table-column
            prop="createdTime"
            min-width="120"
            :show-overflow-tooltip="true"
            label="创建时间"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDate(scope.row.createdTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="180" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="method_edit(scope.row)"
                >编辑限值</el-button
              >
              <el-button
                type="success"
                size="mini"
                @click="getHaccoTemplate(scope.row.id)"
                >编辑工序</el-button
              >
              <el-button
                type="warning"
                size="mini"
                @click="handleEdit(scope.row)"
                >修改</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="handleDelete(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="i-page fr disib mt20">
          <el-pagination
            background
            :page-size="query.limit"
            layout="total,prev, pager, next"
            :total="total"
            :current-page="query.page"
            @current-change="currentChange"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog
        :title="data_dialogTitle"
        :visible.sync="dialogVisible"
        width="400px"
        :before-close="handleCancel"
      >
        <div class="item-content-fix" style="display: flex; gap: 20px">
          <!-- 左侧表单区域 -->
          <div style="flex: 1">
            <el-form
              :model="form"
              :rules="data_rules"
              ref="formRef"
              label-width="100px"
            >
              <el-form-item label="名称" prop="name">
                <el-input
                  v-model="form.name"
                  placeholder="请输入名称"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleCancel">取消</el-button>
              <el-button type="primary" @click="handleSubmit">确定</el-button>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="编辑工序"
        :visible.sync="dialogVisible3"
        width="1200px"
        :before-close="handleCancelProcess"
      >
        <div class="process-editor-container">
          <!-- 左侧工序列表 -->
          <div class="process-list-container">
            <div class="process-header">
              <span class="process-title">工艺工序</span>
              <el-button type="primary" size="small" @click="method_addProcess"
                >新增工序</el-button
              >
            </div>
            <div class="process-list">
              <div
                v-for="process in templateList"
                :key="process.id"
                class="process-item"
                :class="{
                  active: selectedProcess && selectedProcess.id === process.id,
                }"
                @click="selectProcess(process)"
              >
                <div class="process-name">{{ process.name }}</div>
                <div class="process-actions">
                  <el-button
                    type="primary"
                    size="mini"
                    @click.stop="editProcess(process)"
                    >编辑</el-button
                  >
                  <el-button
                    type="danger"
                    size="mini"
                    @click.stop="deleteProcess(process)"
                    >删除</el-button
                  >
                </div>
              </div>
              <div v-if="templateList.length === 0" class="empty-process">
                <el-empty description="暂无工序数据"></el-empty>
              </div>
            </div>
          </div>

          <!-- 右侧工序预览 - 宽度固定为375px -->
          <div class="process-preview-container">
            <div class="preview-title">预览效果</div>
            <div
              v-if="selectedProcess"
              class="preview-content"
              v-html="selectedProcess.note"
            ></div>
            <div v-else class="no-selection">
              <el-empty description="请选择工序进行预览"></el-empty>
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 新增/编辑对话框 -->
      <el-dialog
        :title="data_dialogTitle"
        :visible.sync="dialogVisible2"
        width="1200px"
        :closed="handleCancel"
      >
        <div class="item-content-fix" style="display: flex; gap: 20px">
          <!-- 左侧表单区域 -->
          <div style="flex: 1">
            <el-form
              :model="form1"
              :rules="data_rules"
              ref="formRef"
              label-width="100px"
            >
              <el-form-item label="名称" prop="name">
                <el-input
                  v-model="form1.name"
                  placeholder="请输入名称"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
              <el-form-item label="注意事项" prop="note">
                <div
                  style="
                    border-radius: 4px;
                    border: 1px solid #dcdfe6;
                    overflow: hidden;
                  "
                >
                  <Toolbar
                    style="border-bottom: 1px solid #ccc"
                    :editor="editor"
                    :defaultConfig="toolbarConfig"
                    :mode="mode"
                  />
                  <Editor
                    class="preview-box"
                    style="height: 500px; overflow-y: hidden"
                    v-model="form1.note"
                    :defaultConfig="editorConfig"
                    :mode="mode"
                    @onCreated="onCreated"
                  />
                </div>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="handleCancel">取消</el-button>
              <el-button type="primary" @click="handleSubmitProcess"
                >确定</el-button
              >
            </div>
          </div>

          <!-- 右侧预览区域 -->
          <div style="width: 375px; flex-shrink: 0">
            <div
              class="preview-title"
              style="margin-bottom: 10px; font-weight: bold"
            >
              预览效果
            </div>
            <div
              v-html="form1.note"
              style="
                width: 375px;
                min-height: 667px;
                background-color: #fff;
                border: 1px solid #ccc;
                padding: 15px;
                overflow: hidden;
                max-height: 1060px;
                overflow-y: scroll;
              "
              class="preview-box"
            ></div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="绑定限值"
        :visible.sync="dialogVisible1"
        width="70%"
        class="custom-dialog"
      >
        <el-form :inline="true" :model="query1" class="demo-form-inline">
          <div class="df aic" style="margin-top: 20px">
            <el-form-item
              size="medium"
              class="mr10"
              style="width: auto !important"
            >
              <el-radio-group v-model="radio1">
                <el-radio-button label="全部"></el-radio-button>
                <el-radio-button label="已绑定"></el-radio-button>
              </el-radio-group>
            </el-form-item>
            <template v-if="radio1 == '全部'">
              <el-form-item size="medium" style="flex: 0 0 20%" class="mr10">
                <el-input
                  placeholder="关键词搜索"
                  v-model="query1.keyword"
                  clearable
                  class="input-with-select"
                  @clear="search1"
                >
                </el-input>
              </el-form-item>
              <el-button
                type="primary"
                @click="search1"
                style="height: 34px; margin-bottom: 20px; border: none"
                class="mr10"
                >查询</el-button
              >
            </template>
          </div>
        </el-form>
        <div class="card-grid" v-if="radio1 == '全部'">
          <div
            class="card"
            v-for="item in cardData"
            :key="item.id"
            :class="{ 'selected-card': false }"
            @click="toggleSelect(item.id)"
          >
            <div class="card-header">
              <div class="card-title">{{ item.name }}</div>
              <div class="card-subtitle">{{ item.engName }}</div>
            </div>

            <div class="card-body">
              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["type"] }}:</div>
                <div class="info-content">
                  <div class="tag-group">
                    <span
                      class="tag tag-primary"
                      v-for="func in item.type.split('、')"
                      :key="func"
                    >
                      {{ func }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["foodName"] }}:</div>
                <div class="info-content">{{ item.foodName }}</div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["value1"] }}:</div>
                <div class="info-content">
                  <span class="tag tag-success">{{ item.value1 }}</span>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["value2"] }}:</div>
                <div class="info-content">
                  <span class="tag tag-warning">{{ item.value2 }}</span>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["value3"] }}:</div>
                <div class="info-content">
                  {{ item.value3 }}
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["limitNum"] }}:</div>
                <div class="info-content">{{ item.limitNum }}</div>
              </div>

              <div class="info-row" v-if="item.remark">
                <div class="info-label">{{ item.fieldInfo["remark"] }}:</div>
                <div class="info-content">{{ item.remark }}</div>
              </div>
            </div>

            <div class="card-footer">
              <span class="update-time">
                {{ formatDate(item.createdTime) }}</span
              >
              <el-button
                class="bind-btn"
                :type="
                  cardBindData.length &&
                  cardBindData.filter((v) => v.id == item.id).length
                    ? 'danger'
                    : 'primary'
                "
                size="small"
                @click.stop="
                  toggleBind(
                    item.id,
                    cardBindData.length &&
                      cardBindData.filter((v) => v.id == item.id).length
                  )
                "
              >
                {{
                  cardBindData.length &&
                  cardBindData.filter((v) => v.id == item.id).length
                    ? "解绑"
                    : "绑定"
                }}
              </el-button>
            </div>
          </div>
        </div>
        <div class="card-grid" v-else-if="cardBindData.length">
          <div
            class="card"
            v-for="item in cardBindData"
            :key="item.id"
            :class="{ 'selected-card': false }"
            @click="toggleSelect(item.id)"
          >
            <div class="card-header">
              <div class="card-title">{{ item.name }}</div>
              <div class="card-subtitle">{{ item.engName }}</div>
            </div>

            <div class="card-body">
              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["type"] }}:</div>
                <div class="info-content">
                  <div class="tag-group">
                    <span
                      class="tag tag-primary"
                      v-for="func in item.type.split('、')"
                      :key="func"
                    >
                      {{ func }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["foodName"] }}:</div>
                <div class="info-content">{{ item.foodName }}</div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["value1"] }}:</div>
                <div class="info-content">
                  <span class="tag tag-success">{{ item.value1 }}</span>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["value2"] }}:</div>
                <div class="info-content">
                  <span class="tag tag-warning">{{ item.value2 }}</span>
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["value3"] }}:</div>
                <div class="info-content">
                  {{ item.value3 }}
                </div>
              </div>

              <div class="info-row">
                <div class="info-label">{{ item.fieldInfo["limitNum"] }}:</div>
                <div class="info-content">{{ item.limitNum }}</div>
              </div>

              <div class="info-row" v-if="item.remark">
                <div class="info-label">{{ item.fieldInfo["remark"] }}:</div>
                <div class="info-content">{{ item.remark }}</div>
              </div>
            </div>

            <div class="card-footer">
              <span class="update-time">
                {{ formatDate(item.createdTime) }}</span
              >
              <el-button
                class="bind-btn"
                :type="
                  cardBindData.length &&
                  cardBindData.filter((v) => v.id == item.id).length
                    ? 'danger'
                    : 'primary'
                "
                size="small"
                @click.stop="
                  toggleBind(
                    item.id,
                    cardBindData.length &&
                      cardBindData.filter((v) => v.id == item.id).length
                  )
                "
              >
                {{
                  cardBindData.length &&
                  cardBindData.filter((v) => v.id == item.id).length
                    ? "解绑"
                    : "绑定"
                }}
              </el-button>
            </div>
          </div>
        </div>
        <div class="df aic jcc" style="height: 300px" v-else>
          <el-empty description="未绑定限值"></el-empty>
        </div>
        <div class="df aic jcc mt20" v-if="radio1 == '全部'">
          <el-pagination
            background
            :page-size="10"
            layout="total,prev, pager, next"
            :total="total1"
            :current-page="query1.page"
            @current-change="currentChange1"
          >
          </el-pagination>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import api from "@/util/extra-api";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css";
import { local } from "@/util/util";
import axios from "../../../util/api";

export default {
  components: { Editor, Toolbar },
  data() {
    return {
      dialogVisible1: false,
      dialogVisible2: false,
      query1: {
        keyword: "",
        page: 1,
        limit: 10,
      },
      query: {
        keyword: "",
        page: 1,
        limit: 15,
      },
      total1: 0,
      cardData: [],
      cardBindData: [],
      radio1: "全部",
      checkedId: null,
      templateList: [],

      editor: null,
      toolbarConfig: {
        toolbarKeys: [
          "headerSelect",
          "blockquote",
          "|",
          "bold",
          "underline",
          "italic",
          {
            key: "group-more-style",
            title: "更多",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path></svg>',
            menuKeys: ["through", "sup", "sub", "clearStyle"],
            //  "insertLink"
          },
          "color",
          "bgColor",
          "|",
          "fontSize",
          "fontFamily",
          "lineHeight",
          "|",
          "bulletedList",
          "numberedList",
          {
            key: "group-justify",
            title: "对齐",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',
            menuKeys: [
              "justifyLeft",
              "justifyRight",
              "justifyCenter",
              "justifyJustify",
            ],
          },
          {
            key: "group-indent",
            title: "缩进",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>',
            menuKeys: ["indent", "delIndent"],
          },
          "|",
          // "insertLink",
          {
            key: "group-image",
            title: "图片",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
            menuKeys: ["insertImage", "uploadImage"],
          },
          {
            key: "group-video",
            title: "视频",
            iconSvg:
              '<svg viewBox="0 0 1024 1024"><path d="M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z"></path></svg>',
            menuKeys: ["insertVideo", "uploadVideo"],
          },
          "divider",
          "|",
          "undo",
          "redo",
        ],
      },
      editorConfig: {
        placeholder: "请输入正文...",
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              const fileType = file.type,
                isImage = fileType.indexOf("image") != -1,
                isLt10M = file.size / 1024 / 1024 < 10;

              // 这里常规检验，看项目需求而定
              if (!isImage) {
                this.$message.error("只能上传图片格式png、jpg、gif!");
                return;
              }
              if (!isLt10M) {
                this.$message.error("只能上传图片大小小于10M");
                return;
              }
              const fileFormData = new FormData();
              // fileFormData.append("file", file);
              fileFormData.append("file", file);
              fileFormData.append(
                "company_id",
                0
              );
              fileFormData.append(
                "user_id",
                local.get("user") && local.get("user").user_id
              );
              let resp = await axios.uploadFile(
                "/pc/file/common",
                fileFormData
              );
              // .then((resp) => {});
              if (resp.code != 200) {
                this.$message.error("图片上传失败，请重新上传");
              } else {
                console.log(resp);
                insertFn(resp.url, "", resp.url);
              }
            },
          },
          uploadVideo: {
            async customUpload(file, insertFn) {
              const fileType = file.type,
                isVidoe = fileType.includes("video");
              if (!isVidoe) {
                this.$message.error("只能上传视频格式!");
                return false;
              }
              const fileFormData = new FormData();
              // fileFormData.append("file", file);
              fileFormData.append("file", file);
              fileFormData.append(
                "company_id",
                localStorage.getItem("company_id")
              );
              fileFormData.append(
                "user_id",
                local.get("user") && local.get("user").user_id
              );
              let resp = await axios.uploadFile(
                "/pc/file/common",
                fileFormData
              );
              // .then((resp) => {});
              if (resp.code != 200) {
                this.$message.error("视频上传失败，请重新上传");
              } else {
                console.log(resp);
                insertFn(resp.url, "", resp.url);
              }
            },
          },
        },
      },
      mode: "simple", // or 'default'
      category: "",
      miniCategory: "",
      total: 0,
      data_tableData: [],
      // 对话框数据
      dialogVisible: false,
      data_dialogTitle: "新增模板",
      form: {
        name: "",
        categoryId: "",
      },
      form1: {
        name: "",
        note: "",
        foodTemplateId: "",
      },
      data_rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        note: [
          { required: true, message: "请输入注意事项", trigger: "change" },
        ],
      },
      dialogVisible3: false, // 编辑工序弹窗显示控制
      selectedProcess: null, // 当前选中的工序
    };
  },
  mounted() {
    this.categoryId = this.$route.query.id;
    // console.log(this.categoryId);
    this.getLimitData();
    this.method_init();
  },
  methods: {
    // 新增方法：编辑工序
    method_editProcess(row) {
      this.checkedId = row.id;
      this.dialogVisible3 = true;
      this.getHaccoTemplate(row.id);
    },

    // 新增方法：选择工序
    selectProcess(process) {
      this.selectedProcess = process;
    },

    // 新增方法：新增工序
    method_addProcess() {
      this.form1 = {
        name: "",
        note: "",
        foodTemplateId: this.checkedId,
      };
      this.data_dialogTitle = "新增工序";
      this.dialogVisible2 = true;
      this.dialogVisible3 = false;
    },

    // 新增方法：编辑工序
    editProcess(process) {
      this.selectedProcess = process;
      this.form1 = {
        name: process.name,
        note: process.note,
        foodTemplateId: this.checkedId,
        id: process.id,
      };
      this.data_dialogTitle = "编辑工序";
      this.dialogVisible2 = true;
      this.dialogVisible3 = false;
    },

    // 新增方法：删除工序
    deleteProcess(process) {
      this.$confirm("确认删除该工序吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 这里调用删除工序的API
        api
          .post("/v1/pc/foodHaccpTemplate/deleteHaccpTemplate", {
            id: process.id,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.getHaccoTemplate(this.checkedId);
            }
          });
      });
    },

    // 修改现有方法：处理工序表单提交
    handleSubmitProcess() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          console.log(this.checkedId, "测试");

          // 调用新增工序的API
          this.form1.foodTemplateId = this.checkedId; // 确保tempId是正确的值
          // this.form1.tempId = this.checkedId; // 确保tempId是正确的值
          console.log(this.form1, "测试");
          if (this.form1.id) {
            this.updateHaccpTemplate();
          } else {
            this.addHaccpTemplate();
          }
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },

    // 修改现有方法：实现新增工序
    addHaccpTemplate() {
      api
        .post("/v1/pc/foodHaccpTemplate/addHaccpTemplate", this.form1)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogVisible2 = false;
            this.dialogVisible3 = true;
            this.getHaccoTemplate(this.checkedId);
          }
        });
    },
    updateHaccpTemplate() {
      api
        .post("/v1/pc/foodHaccpTemplate/updateHaccpTemplate", this.form1)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.dialogVisible2 = false;
            this.dialogVisible3 = true;
            this.getHaccoTemplate(this.checkedId);
          }
        });
    },
    // 新增方法：取消工序编辑
    handleCancelProcess() {
      this.dialogVisible3 = false;
      this.selectedProcess = null;
    },

    // addHaccpTemplate() {
    //   // /v1/pc/foodHaccpTemplate/addHaccpTemplate
    // },
    getHaccoTemplate(foodTemplateId) {
      this.checkedId = foodTemplateId;
      api
        .get("/v1/pc/foodHaccpTemplate/getHaccoTemplate", {
          foodTemplateId,
        })
        .then((res) => {
          this.templateList = res.data;
          this.dialogVisible3 = true;
        });
      // /v1/pc/foodHaccpTemplate/getHaccoTemplate
    },
    getBindLimitData(tempId) {
      api
        .get("/v1/pc/foodHaccpTemplate/getLimitData", {
          tempId,
        })
        .then((res) => {
          if (res.code === 200) {
            this.cardBindData = res.data.map((v) => {
              let fieldInfo = {};
              JSON.parse(v.fieldInfo).forEach((v) => {
                fieldInfo[v.field] = v.name;
              });
              return {
                ...v,
                fieldInfo,
              };
            });
          }
        });
    },

    getLimitData() {
      api.get("/v1/pc/foodHaccpTemplate/limitData", this.query1).then((res) => {
        if (res.code === 200) {
          //   console.log(res.data, "测试");
          this.total1 = res.total;

          this.cardData = res.data.map((v) => {
            let fieldInfo = {};
            JSON.parse(v.fieldInfo).forEach((v) => {
              fieldInfo[v.field] = v.name;
            });
            return {
              ...v,
              fieldInfo,
            };
          });
        }
      });
    },
    search1() {
      this.query1.page = 1;
      this.getLimitData();
    },
    toggleBind(id, isBind) {
      if (!isBind) {
        api
          .post("/v1/pc/foodHaccpTemplate/addLimitData", {
            tempId: this.checkedId,
            limitDataId: id,
          })
          .then((res) => {
            if (res.code === 200) {
              this.getBindLimitData(this.checkedId);
            }
          });
      } else {
        api
          .get("/v1/pc/foodHaccpTemplate/deleteLimitData", {
            limitDataId: id,
            tempId: this.checkedId,
          })
          .then((res) => {
            if (res.code === 200) {
              this.getBindLimitData(this.checkedId);
            }
          });
      }
    },
    currentChange1(page) {
      this.query1.page = page;
      this.getLimitData();
    },
    method_edit(row) {
      this.checkedId = row.id;
      this.getBindLimitData(row.id);
      this.dialogVisible1 = true;
      // this.dialogTitle = "修改数据";
      // this.data_form = {
      //   id: row.head_id,
      //   name: row.head_name,
      //   type: row.head_type,
      //   status: row.head_status,
      //   description: row.head_description,
      // };
      // this.dialogVisible = true;
    },
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return "";
      return dateStr.replace("T", " ");
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.editor.customConfig.linkCheck = this.customCheckLinkFn;
    },
    customCheckLinkFn(text, url) {
      if (!url) {
        return;
      }
      if (url.indexOf("http") !== 0) {
        return "链接必须以 http/https 开头";
      }
      return true;
    },
    // 初始化数据
    method_init() {
      api
        .get("/v1/pc/foodHaccpTemplate/getFoodHaccp", {
          categoryId: this.categoryId,
          ...this.query,
        })
        .then((res) => {
          if (res.code === 200) {
            this.data_tableData = res.data;
            this.total = res.total;
          }
        });
    },

    // 搜索
    // search() {
    //   this.query.page = 1;
    //   //   this.method_init(this.query);
    // },

    // 分页切换
    currentChange(page) {
      this.query.page = page;
      this.method_init();
    },
    handleEdit(row) {
      this.data_dialogTitle = "修改工艺";
      this.form = {
        name: row.name,
        note: row.note,
        id: row.id,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },
    // 新增
    method_add() {
      this.data_dialogTitle = "新增工艺";
      this.form = {
        name: "",
        note: "",
        id: "",
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate();
        }
      });
    },

    // 切换状态
    toggleStatus(row) {
      const newStatus = row.status === "1" ? "0" : "1";
      const statusText = newStatus === "1" ? "启用" : "禁用";

      this.$confirm(`确认${statusText}该模板吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api
          .post("/v1/pc/template/updateStatus", {
            id: row.id,
            status: newStatus,
          })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(`${statusText}成功`);
              this.method_init();
            } else {
              this.$message.error(res.msg || `${statusText}失败`);
            }
          })
          .catch((err) => {
            console.error(err);
            this.$message.error("网络错误");
          });
      });
    },

    // 删除
    handleDelete(row) {
      this.$confirm("确认删除该模板吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api
          .get("/v1/pc/foodHaccpTemplate/deleteFoodHaccp", { id: row.id })
          .then((res) => {
            if (res.code === 200) {
              this.$message.success("删除成功");
              this.method_init();
            }
          });
      });
    },
    // 取消对话框
    handleCancel() {
      this.dialogVisible = false;
      this.$refs["formRef"].resetFields();
    },

    // 提交表单
    handleSubmit() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          const url =
            this.form.id !== ""
              ? "/v1/pc/foodHaccpTemplate/update"
              : "/v1/pc/foodHaccpTemplate/add";
          let data =
            this.form.id !== ""
              ? this.form
              : {
                  name: this.form.name,
                  note: this.form.note,
                  categoryId: this.categoryId,
                };

          api.post(url, data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.form.id ? "修改成功" : "新增成功");
              this.method_init();
              this.handleCancel();
            }
          });
        } else {
          console.log("表单验证失败");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.data-container {
  overflow-x: hidden;
  .add {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /deep/ .el-input-group__append .el-button--primary .el-icon-search {
    color: #fff;
  }
}

.add-btn {
  flex: 0 0 200px;
}

.i-page {
  text-align: right;
  margin-top: 20px;
}

.item-content-fix {
  /deep/.el-form-item__content {
    width: calc(100% - 120px) !important;
    box-sizing: border-box;
  }
}

.df {
  display: flex;
}
.aic {
  align-items: center;
}
.bb {
  border-bottom: 1px solid #ebeef5;
}
.p15 {
  padding: 15px;
}
.pt0 {
  padding-top: 0;
}
.mr10 {
  margin-right: 10px;
}
.mt20 {
  margin-top: 20px;
}
.fr {
  float: right;
}
.disib {
  display: inline-block;
}

.preview-box {
  /deep/ strong {
    font-weight: bold !important;
  }
  /deep/ em {
    font-style: italic !important;
  }
  /deep/ ol li {
    list-style-type: decimal !important;
    list-style-position: inside !important;
  }
  /deep/ ul li {
    list-style-type: disc !important;
    list-style-position: inside !important;
  }
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
  .card {
    background: white;
    border-radius: 6px;
    border: 1px solid #e8e8e8;
    transition: all 0.3s;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .card:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
    border-color: #d9d9d9;
  }

  .card-header {
    text-align: left;
    padding: 12px 16px;
    background-color: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    position: relative;
  }

  .card-title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 4px;
    color: #333;
  }

  .card-subtitle {
    font-size: 13px;
    color: #666;
  }

  .card-badge {
    position: absolute;
    top: 12px;
    right: 16px;
    background: #f0f0f0;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 11px;
    color: #666;
  }

  .card-body {
    padding: 16px;
    flex: 1;
  }

  .info-row {
    display: flex;
    margin-bottom: 10px;
    align-items: flex-start;
  }

  .info-label {
    width: 80px;
    font-weight: 500;
    color: #666;
    font-size: 13px;
    flex-shrink: 0;
  }

  .info-content {
    flex: 1;
    font-size: 13px;
    color: #333;
  }

  .tag-group {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  .tag {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 11px;
    background: #f5f5f5;
    color: #666;
    border: 1px solid #e8e8e8;
  }

  .tag-primary {
    background: #e6f7ff;
    color: #1890ff;
    border-color: #91d5ff;
  }

  .tag-warning {
    background: #fff7e6;
    color: #fa8c16;
    border-color: #ffd591;
  }

  .tag-success {
    background: #f6ffed;
    color: #52c41a;
    border-color: #b7eb8f;
  }

  .card-footer {
    padding: 12px 16px;
    background-color: #fafafa;
    border-top: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .info-row:last-child {
    margin: 0;
  }
}
// 优化后的样式
.process-editor-container {
  display: flex;
  height: 600px;
  gap: 20px;
}

.process-list-container {
  flex: 1;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
}

.process-header {
  padding: 12px 16px;
  border-bottom: 1px solid #dcdfe6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f5f7fa;
}

.process-title {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}

.process-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}

.process-item {
  padding: 12px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin-bottom: 8px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s;
  background: #fff;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  }

  &.active {
    border-color: #409eff;
    background-color: #ecf5ff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  }
}

.process-name {
  font-weight: 500;
  color: #303133;
  font-size: 14px;
}

.process-actions {
  display: flex;
  gap: 8px;
}

.empty-process {
  padding: 50px 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.process-preview-container {
  width: 375px;
  flex-shrink: 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
}

.preview-title {
  padding: 12px 16px;
  border-bottom: 1px solid #dcdfe6;
  font-weight: bold;
  background-color: #f5f7fa;
  font-size: 16px;
  color: #303133;
}

.preview-content {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  background-color: #fff;
  max-height: 1060px;
  overflow-y: scroll;

  // 与dialogVisible2中的预览样式保持一致
  /deep/ strong {
    font-weight: bold !important;
  }
  /deep/ em {
    font-style: italic !important;
  }
  /deep/ ol li {
    list-style-type: decimal !important;
    list-style-position: inside !important;
  }
  /deep/ ul li {
    list-style-type: disc !important;
    list-style-position: inside !important;
  }
}

.no-selection {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
</style>